import { useState } from 'react';
import { s } from '../constants/styles';
import { calcPlates, calc1RM } from '../utils/calculations';

export default function ToolsView() {
  const [tool, setTool] = useState("plates");
  return (
    <div className="fade-in" style={{ padding: 20, paddingBottom: 100 }}>
      <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 14 }}>Tools</h2>
      <div style={{ display: "flex", gap: 6, marginBottom: 20 }}>
        {[{ id: "plates", label: "Plate Calc" }, { id: "orm", label: "1RM Calc" }].map(t => (
          <button key={t.id} onClick={() => setTool(t.id)} style={{
            flex: 1, padding: "12px 0", borderRadius: 12, fontSize: 13, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
            background: tool === t.id ? "rgba(79,143,255,0.12)" : "var(--bg-2)",
            color: tool === t.id ? "#4f8fff" : "var(--text-3)",
          }}>{t.label}</button>
        ))}
      </div>
      {tool === "plates" ? <PlateCalc /> : <OneRMCalc />}
    </div>
  );
}

function PlateCalc() {
  const [targetStr, setTargetStr] = useState("135");
  const [bar, setBar] = useState(45);
  const target = Number(targetStr) || 0;
  const plates = calcPlates(target, bar);
  const actual = bar + plates.reduce((a, p) => a + p, 0) * 2;
  const colors = { 45: "#ef4444", 35: "#f59e0b", 25: "#22c55e", 10: "#3b82f6", 5: "#8b5cf6", 2.5: "#ec4899" };
  function adjust(v) { const n = Math.max(bar, target + v); setTargetStr(String(n)); }
  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <div style={s.label}>BAR</div>
        <div style={{ display: "flex", gap: 5 }}>
          {[45, 35, 25, 15].map(b => (
            <button key={b} onClick={() => setBar(b)} style={{
              flex: 1, padding: "10px 0", borderRadius: 10, fontSize: 14, fontWeight: 700, border: "none", cursor: "pointer", fontFamily: "inherit",
              background: bar === b ? "rgba(79,143,255,0.12)" : "var(--bg-2)", color: bar === b ? "#4f8fff" : "var(--text-3)",
            }}>{b}</button>
          ))}
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={s.label}>TARGET WEIGHT</div>
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <button onClick={() => adjust(-10)} style={{ ...s.btnG, minWidth: 40, height: 48, fontSize: 12, fontWeight: 800, color: "var(--red)", padding: "0 6px", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>-10</button>
          <button onClick={() => adjust(-5)} style={{ ...s.btnG, minWidth: 36, height: 48, fontSize: 12, fontWeight: 800, color: "var(--red)", padding: "0 6px", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>-5</button>
          <input type="number" inputMode="numeric" value={targetStr} onChange={e => setTargetStr(e.target.value)} onBlur={() => { if (!targetStr) setTargetStr("0"); }}
            style={{ flex: 1, minWidth: 0, textAlign: "center", fontSize: 28, fontWeight: 800, padding: "8px 4px", borderRadius: 12, background: "var(--bg-2)", color: "var(--text-1)", border: "1px solid rgba(255,255,255,0.06)", outline: "none", fontFamily: "inherit" }} />
          <button onClick={() => adjust(5)} style={{ ...s.btnG, minWidth: 36, height: 48, fontSize: 12, fontWeight: 800, color: "var(--green)", padding: "0 6px", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>+5</button>
          <button onClick={() => adjust(10)} style={{ ...s.btnG, minWidth: 40, height: 48, fontSize: 12, fontWeight: 800, color: "var(--green)", padding: "0 6px", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>+10</button>
        </div>
      </div>
      {target > bar ? (
        <div style={{ ...s.card, ...s.cardGlow, padding: 18 }}>
          <div style={{ ...s.label, marginBottom: 10 }}>EACH SIDE — {(target - bar) / 2} LBS</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
            {plates.map((p, i) => (
              <div key={i} style={{ padding: "10px 18px", borderRadius: 10, fontSize: 17, fontWeight: 800, background: `${colors[p]}15`, color: colors[p], border: `1px solid ${colors[p]}30` }}>{p}</div>
            ))}
          </div>
          {actual !== target && <div style={{ fontSize: 12, color: "var(--amber)" }}>Closest loadable: {actual} lbs</div>}
        </div>
      ) : (
        <div style={{ ...s.card, padding: 18, textAlign: "center", color: "var(--text-3)" }}>Just the bar!</div>
      )}
    </div>
  );
}

function OneRMCalc() {
  const [weightStr, setWeightStr] = useState("185");
  const [repsStr, setRepsStr] = useState("5");
  const weight = Number(weightStr) || 0;
  const reps = Math.max(1, Number(repsStr) || 1);
  const orm = calc1RM(weight, reps);
  const pcts = [100, 95, 90, 85, 80, 75, 70, 65, 60];
  return (
    <div style={{ contain: "layout style" }}>
      <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
        <div style={{ flex: 1 }}>
          <div style={s.label}>WEIGHT (LBS)</div>
          <input type="number" inputMode="numeric" value={weightStr} onChange={e => setWeightStr(e.target.value)} onBlur={() => { if (!weightStr) setWeightStr("0"); }}
            style={{ ...s.inp, textAlign: "center", fontSize: 22, fontWeight: 800, padding: "10px 0", height: 52 }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={s.label}>REPS</div>
          <input type="number" inputMode="numeric" value={repsStr} onChange={e => setRepsStr(e.target.value)} onBlur={() => { if (!repsStr) setRepsStr("1"); }}
            style={{ ...s.inp, textAlign: "center", fontSize: 22, fontWeight: 800, padding: "10px 0", height: 52 }} />
        </div>
      </div>
      <div style={{ ...s.card, ...s.cardGlow, padding: 18, textAlign: "center", marginBottom: 16 }}>
        <div style={{ ...s.label, marginBottom: 2 }}>ESTIMATED 1RM</div>
        <div style={{ fontSize: 36, fontWeight: 800, color: "var(--accent)" }}>{orm} <span style={{ fontSize: 14, color: "var(--text-3)" }}>lbs</span></div>
        <div style={{ fontSize: 11, color: "var(--text-3)", marginTop: 2 }}>Epley formula</div>
      </div>
      <div style={{ ...s.label, marginBottom: 6 }}>PERCENTAGE TABLE</div>
      {pcts.map(p => (
        <div key={p} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", borderRadius: 9, marginBottom: 2, background: p === 100 ? "rgba(79,143,255,0.06)" : "var(--bg-2)", height: 40 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: p === 100 ? "var(--accent)" : "var(--text-2)" }}>{p}%</span>
          <span style={{ fontSize: 15, fontWeight: 800, fontVariantNumeric: "tabular-nums" }}>{Math.round(orm * p / 100)} lbs</span>
        </div>
      ))}
    </div>
  );
}
